import { __extends, __makeTemplateObject, __decorate, __metadata, __assign as _assign } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x, nothing as A } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { ScopedElementsMixin } from '../utilities/scoped-elements/scoped-elements.mixin.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { PvdAnimation } from '../pvd-utils/scripts/animation.js';
import { HeadingLevel } from '../pvd-utils/enums/heading-level.js';
import { Size } from '../pvd-utils/enums/size.js';

var AlertVariant;
(function (AlertVariant) {
    AlertVariant["critical"] = "critical";
    AlertVariant["info"] = "info";
    AlertVariant["success"] = "success";
    AlertVariant["warning"] = "warning";
})(AlertVariant || (AlertVariant = {}));
var AlertIconName;
(function (AlertIconName) {
    AlertIconName["critical"] = "alert__critical--outline";
    AlertIconName["info"] = "alert__info--outline";
    AlertIconName["success"] = "alert__success";
    AlertIconName["warning"] = "alert__warning--outline";
})(AlertIconName || (AlertIconName = {}));
var DEFAULT_VARIANT = AlertVariant.critical;
var DEFAULT_DISMISS_BTN_TEXT = 'Dismiss alert';
var DISMISS_ANIMATION_DURATION = 150;
var DISMISS_ANIMATION_DELAY = 150;
var DEFAULT_TITLE_HEADING_LEVEL = HeadingLevel.two;
/**
 * Providence Alert component.
 * @see {@link https://providence.fmr.com/components/alert/alert.html|Alert documentation}
 */
var PvdAlert = /** @class */ (function (_super) {
    __extends(PvdAlert, _super);
    function PvdAlert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pvdDisableA11yAttributes = false;
        _this.pvdDismissIconA11yText = DEFAULT_DISMISS_BTN_TEXT;
        _this.pvdDismissible = false;
        _this.pvdTitleHeadingLevel = DEFAULT_TITLE_HEADING_LEVEL;
        _this.pvdVariant = DEFAULT_VARIANT;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdAlert, "scopedElements", {
        get: function () {
            // $namespace-$name-$extendingComponentName
            return {
                'pvd-scoped-icon': customElements.get("".concat(this.namespace, "-icon")),
            };
        },
        enumerable: false,
        configurable: true
    });
    // #endregion
    // #region public methods
    PvdAlert.prototype.closeAlert = function () {
        var _this = this;
        // needing to get the immediate div to get actual height
        var currAlert = this.querySelector(".".concat(this.constructor.namespace, "-alert-root"));
        if (currAlert) {
            // adding class for opacity transition
            currAlert.classList.add('pvd-alert--closing');
            var animation_1 = new PvdAnimation(currAlert, 'height', DISMISS_ANIMATION_DURATION);
            // setting a delay before we start closing the alert (design reqs)
            setTimeout(function () {
                // once alert is done animating its height close, remove it from the dom
                currAlert.addEventListener('pvd-animation:end', function () {
                    _this.triggerAlertClosedEvent();
                    _this.removeAlert();
                });
                animation_1.start(0);
            }, DISMISS_ANIMATION_DELAY);
        }
    };
    PvdAlert.prototype.removeAlert = function () {
        // actual removal of the alert from the DOM
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
        // alert user the alert has been completely removed
        this.triggerAlertRemovedEvent();
    };
    Object.defineProperty(PvdAlert.prototype, "iconName", {
        // #endregion
        // # region private methods
        get: function () {
            return AlertIconName[this.pvdVariant.toLowerCase()];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdAlert.prototype, "roleAttribute", {
        get: function () {
            // if user does not want to use a11y attributes, do not create attributes
            if (this.pvdDisableA11yAttributes) {
                return undefined;
            }
            return this.pvdDismissible
                ? 'alertdialog'
                : this.pvdVariant === AlertVariant.critical
                    ? 'alert'
                    : 'status';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdAlert.prototype, "ariaLiveAttribute", {
        get: function () {
            // if user does not want to use a11y attributes, do not create attributes
            if (this.pvdDisableA11yAttributes) {
                return undefined;
            }
            return this.pvdVariant === AlertVariant.critical ? 'assertive' : 'polite';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdAlert.prototype, "a11yText", {
        get: function () {
            return this.pvdA11yText ? this.pvdA11yText : this.pvdVariant + ' message';
        },
        enumerable: false,
        configurable: true
    });
    // #endregion
    // #region events
    PvdAlert.prototype.triggerAlertClosedEvent = function () {
        var event = new CustomEvent('pvd-alert-closed', { bubbles: true });
        this.dispatchEvent(event);
    };
    PvdAlert.prototype.triggerAlertRemovedEvent = function () {
        var event = new CustomEvent('pvd-alert-removed');
        this.dispatchEvent(event);
    };
    // #endregion
    // #region LitElement lifecycles
    PvdAlert.prototype.renderAlertIcon = function () {
        return this.scopeTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<pvd-scoped-icon\n      pvd-name=\"", "\"\n      pvd-size=\"", "\"\n    ></pvd-scoped-icon>"], ["<pvd-scoped-icon\n      pvd-name=\"", "\"\n      pvd-size=\"", "\"\n    ></pvd-scoped-icon>"])), this.iconName, Size.large);
    };
    PvdAlert.prototype.renderCloseIcon = function () {
        return this.scopeTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["<pvd-scoped-icon\n      pvd-name=\"action__close\"\n      pvd-size=\"", "\"\n    ></pvd-scoped-icon>"], ["<pvd-scoped-icon\n      pvd-name=\"action__close\"\n      pvd-size=\"", "\"\n    ></pvd-scoped-icon>"])), Size.extraSmall);
    };
    PvdAlert.prototype.renderTitleHeading = function () {
        switch (this.pvdTitleHeadingLevel) {
            case 2:
                return x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["<h2 class=\"pvd-alert__title\">", "</h2>"], ["<h2 class=\"pvd-alert__title\">", "</h2>"])), this.pvdTitle);
            case 3:
                return x(templateObject_4 || (templateObject_4 = __makeTemplateObject(["<h3 class=\"pvd-alert__title\">", "</h3>"], ["<h3 class=\"pvd-alert__title\">", "</h3>"])), this.pvdTitle);
            case 4:
                return x(templateObject_5 || (templateObject_5 = __makeTemplateObject(["<h4 class=\"pvd-alert__title\">", "</h4>"], ["<h4 class=\"pvd-alert__title\">", "</h4>"])), this.pvdTitle);
            case 5:
                return x(templateObject_6 || (templateObject_6 = __makeTemplateObject(["<h5 class=\"pvd-alert__title\">", "</h5>"], ["<h5 class=\"pvd-alert__title\">", "</h5>"])), this.pvdTitle);
            case 6:
                return x(templateObject_7 || (templateObject_7 = __makeTemplateObject(["<h6 class=\"pvd-alert__title\">", "</h6>"], ["<h6 class=\"pvd-alert__title\">", "</h6>"])), this.pvdTitle);
        }
    };
    PvdAlert.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-alert-root"),
            modifierPrefix: 'pvd-alert',
            modifiers: [
                {
                    condition: true,
                    className: this.pvdVariant,
                },
            ],
        };
        return x(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      <div\n        class=\"", "\"\n        role=\"", "\"\n        aria-live=\"", "\"\n      >\n        <div class=\"pvd-alert__icon\">", "</div>\n        <div class=\"pvd-alert__content\">\n          <span class=\"pvd-alert__content-a11y-text\">", "</span>\n          ", "\n          <p class=\"pvd-alert__message\">\n            <s-slot>", "</s-slot>\n          </p>\n        </div>\n        ", "\n      </div>\n    "], ["\n      <div\n        class=\"", "\"\n        role=\"", "\"\n        aria-live=\"", "\"\n      >\n        <div class=\"pvd-alert__icon\">", "</div>\n        <div class=\"pvd-alert__content\">\n          <span class=\"pvd-alert__content-a11y-text\">", "</span>\n          ", "\n          <p class=\"pvd-alert__message\">\n            <s-slot>", "</s-slot>\n          </p>\n        </div>\n        ", "\n      </div>\n    "])), getClassName(classMap), l(this.roleAttribute), l(this.ariaLiveAttribute), this.renderAlertIcon(), this.a11yText, l(this.pvdTitle ? this.renderTitleHeading() : A), this.pvdText, this.pvdDismissible
            ? x(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n              <button class=\"pvd-alert__dismiss-button\" @click=\"", "\" type=\"button\">\n                <span class=\"pvd-alert__dismiss-button-a11y-text\"\n                  >", "</span\n                >\n                ", "\n              </button>\n            "], ["\n              <button class=\"pvd-alert__dismiss-button\" @click=\"", "\" type=\"button\">\n                <span class=\"pvd-alert__dismiss-button-a11y-text\"\n                  >", "</span\n                >\n                ", "\n              </button>\n            "])), this.closeAlert, this.pvdDismissIconA11yText, this.renderCloseIcon()) : '');
    };
    //#region Component configuration
    PvdAlert.componentName = 'alert';
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-a11y-text',
        }),
        __metadata("design:type", String)
    ], PvdAlert.prototype, "pvdA11yText", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-disable-a11y-attributes' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-disable-a11y-attributes'))),
        __metadata("design:type", Boolean)
    ], PvdAlert.prototype, "pvdDisableA11yAttributes", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-dismiss-icon-a11y-text',
        }),
        __metadata("design:type", String)
    ], PvdAlert.prototype, "pvdDismissIconA11yText", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-dismissible' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-dismissible'))),
        __metadata("design:type", Boolean)
    ], PvdAlert.prototype, "pvdDismissible", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-text' }),
        __metadata("design:type", String)
    ], PvdAlert.prototype, "pvdText", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-title' }),
        __metadata("design:type", String)
    ], PvdAlert.prototype, "pvdTitle", void 0);
    __decorate([
        n({ type: Number, reflect: true, attribute: 'pvd-title-heading-level' }),
        __metadata("design:type", Number)
    ], PvdAlert.prototype, "pvdTitleHeadingLevel", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-variant' }, PvdSlotifyBaseComponent.hasChanged(AlertVariant))),
        __metadata("design:type", String)
    ], PvdAlert.prototype, "pvdVariant", void 0);
    return PvdAlert;
}(ScopedElementsMixin(PvdSlotifyBaseComponent)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;

export { AlertIconName, AlertVariant, DEFAULT_DISMISS_BTN_TEXT, DEFAULT_TITLE_HEADING_LEVEL, DEFAULT_VARIANT, DISMISS_ANIMATION_DELAY, DISMISS_ANIMATION_DURATION, PvdAlert };
